import * as React from "react";
import ObAssetsDetlSym from "../../instruments/details/obAssetsDetlSym";
import EdButton from "../../../../generic/edButton";
import Tab from "../../../../generic/tab";
import ObEqDtlContent from "./obEqDtlContent";
import { ObAssetsDetlSymProps } from "../../instruments/details/obAssetsDetlSym";
import { dateTimeFormat } from "../../../../service/dateTimeService";
import moment from "moment";
import { ChipStatusComb } from "../../obConstants";
import { AEqGetTradeBk } from "../../../../service/orderBook/obApiService";
import ObAssetDetailPopup from "../../generic/obAssetDetailPopup";
import ObEquityConvertDesk from "../../obConvertPositions/obEquityConvertDesk";
import ObTradeTabContent from "../../obConvertPositions/obTradeTabContent";
import { backButtonValue } from "./../../obJsXConstants";
import "../../../../../assets/scss/components/toc/orderBook/obModifyState/obModify.scss";
import "../../../../../assets/scss/components/toc/orderBook/obDetails/obOrderLog.scss";
import "../../../../../assets/scss/components/toc/orderBook/obDetails/obAssetDetails.scss";
import "../../../../../assets/scss/components/toc/orderBook/obDetails/obAssetDetailstab.scss";
import { IListObj } from "../../../../types/genericTypes";

export interface ObEqDtlsOpenProps {
	data: any;
	onBackClick: (event: React.MouseEvent<HTMLButtonElement>) => void; // the function to be called onClick
	isTodayOrder: boolean;
	onCancelClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export interface ObEqDtlsOpenState {
	selectedTab: string | number;
	tradeData: Array<any>;
	showTradePopup: boolean;
	tabLst: Array<IListObj>;
}

class ObEqDtlsOpen extends React.Component<ObEqDtlsOpenProps, ObEqDtlsOpenState> {
	tabList: Array<IListObj> = [
		{ value: "info", display: "Info" },
		{ value: "trade", display: "Trades" }
	];
	state = { selectedTab: "info", tradeData: [], showTradePopup: false, tabLst: [this.tabList[0]] };

	assetDetail: ObAssetsDetlSymProps = {
		date: this.props.data.rcvEpTim
			? moment(dateTimeFormat(this.props.data.rcvEpTim)).format("D MMM YYYY, HH:mm:ss")
			: moment(dateTimeFormat(this.props.data.ordEntTyp)).format("D MMM YYYY, HH:mm:ss"),
		trsTyp: this.props.data.trsTyp,
		title: this.props.data.trdSym,
		subTitle: this.props.data.cpName ? this.props.data.cpName : this.props.data.dpName ? this.props.data.dpName : this.props.data.symName,
		sts: this.props.data.sts && ChipStatusComb[this.props.data.sts.toLowerCase()]
	};

	tabLstSelect = (id: string | number) => {
		this.setState({ selectedTab: id });
	};

	eqGetTradeBkRes = (res: any) => {
		if (res.data) {
			if (res.data.trade.length > 0) {
				this.setState({
					tradeData: res.data.trade,
					tabLst: this.tabList
				});
			}
		}
	};

	componentDidMount() {
		AEqGetTradeBk(this.eqGetTradeBkRes, this.props.data.ordID);
	}

	render() {
		return (
			<>
				<section className="ob_detail_container">
					<section className="ob_detail_wrapper">
						<section className="list_view">
							<div className="ly_list_view ">
								{/* left menu back button */}
								<div className="lv_menu bckBtnDiv ">
									<EdButton value={backButtonValue} btnTyp="link" onClick={this.props.onBackClick} className="icon_button" />
								</div>
							</div>

							<div className="ob_right_cont ly_right_cont">
								<div className="ob_detail_view">
									{/* header section */}
									<div className="dv_content">
										<div className="ob_header">
											<ObAssetsDetlSym {...this.assetDetail} />
											{/* when status is rejected will show below content */}
											{this.props.data.rjRsn && (
												<div className="rjct_reason">
													<p className="rsn_hd">Reason</p>
													<p className="rsn">{this.props.data.rjRsn}</p>
												</div>
											)}
										</div>
										{/* detailed content */}
										<div>
											<Tab
												defaultValue={this.state.selectedTab}
												tabList={this.state.tabLst}
												onSelect={this.tabLstSelect}
												position="left"
											/>

											{/*  if tab is info then show info content */}
											<div className={"info" + (this.state.selectedTab === "info" ? " show" : " hide")}>
												<ObEqDtlContent
													data={this.props.data}
													isTodayOrder={this.props.isTodayOrder}
													showTradeTab={this.state.tradeData.length > 0}
													tradeData={this.state.tradeData}
													onCancelClick={this.props.onCancelClick}
												/>
											</div>
											{/* if the tab is trade then show trade content below */}
											<div className={"trade" + (this.state.selectedTab === "trade" ? " show" : " hide")}>
												<div className="mg-t20 mg-b20 trad_desk_wrap">
													<ul className="ob_conver_tbl">
														{this.state.tradeData.map((data, index) => (
															<ObTradeTabContent key={index} showCheckbox={false} data={data} />
														))}
													</ul>
													<div className="convrt_btn_con">
														<EdButton
															value="Convert Positions"
															btnTyp="primary"
															onClick={() => {
																this.setState({ showTradePopup: true });
															}}
															slim
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
					</section>
				</section>
				{this.state.showTradePopup && (
					<ObAssetDetailPopup>
						<ObEquityConvertDesk data={this.state.tradeData} onBackClick={() => this.setState({ showTradePopup: false })} />
					</ObAssetDetailPopup>
				)}
			</>
		);
	}
}

export default ObEqDtlsOpen;
